import { Box, Typography, IconButton } from "@mui/material";
import React, { useState, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import uploadbutton from "../../assets/images/uploadbutton.svg";
import { getFileIcon } from "../../utils/getFileIcon";

const normalizeForCompare = (s) =>
  String(s || "")
    .toLowerCase()
    .replace(/\s+/g, "");

const extensionOf = (fileName) => {
  const parts = String(fileName || "").split(".");
  if (parts.length < 2) return "";
  return `.${parts.pop().toLowerCase()}`;
};

const fileMatchesAccept = (file, acceptStr) => {
  if (!acceptStr || !String(acceptStr).trim()) return true;
  const ext = extensionOf(file.name);
  const allowed = String(acceptStr)
    .split(",")
    .map((x) => x.trim().toLowerCase())
    .filter(Boolean);
  return allowed.some((token) => {
    if (token.startsWith(".")) return ext === token;
    return (file.type || "").toLowerCase() === token;
  });
};

const FileRead = ({
  setFile,
  name,
  errors,
  accept = ".csv,.xlsx,.xls,.xlsm",
  fileNameMustInclude = null,
}) => {
  const [isDragOver, setIsDragOver] = useState(false);
  const [file, setFileState] = useState(null);
  const [localError, setLocalError] = useState(null);
  const fileInputRef = useRef(null);

  const validateAndSetFile = (selectedFile) => {
    if (!selectedFile) return;
    if (!fileMatchesAccept(selectedFile, accept)) {
      setLocalError(
        `Invalid file type. Allowed: ${accept.replace(/,/g, ", ")}`,
      );
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }
    if (fileNameMustInclude) {
      const needle = normalizeForCompare(fileNameMustInclude);
      const hay = normalizeForCompare(selectedFile.name);
      if (!needle || !hay.includes(needle)) {
        setLocalError(
          `Please upload the ${fileNameMustInclude} template file (filename must include "${fileNameMustInclude}").`,
        );
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
    }
    setLocalError(null);
    setFile(selectedFile);
    setFileState(selectedFile);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
    validateAndSetFile(selectedFile);
  };

  const handleDeleteFile = () => {
    setFile(null);
    setFileState(null);
    setLocalError(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      validateAndSetFile(files[0]);
    }
  };

  console.log("first2", file);

  return (
    <Box>
      {file && (
        <Box
          mb={2}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            border: "1px solid #ddd",
            borderRadius: "4px",
            backgroundColor: "#f9f9f9",
            padding: "0.5rem",
            width: "33%",
          }}
        >
          <Typography
            variant="caption"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {getFileIcon(file.name)}
            {file.name}
          </Typography>
          <IconButton
            onClick={handleDeleteFile}
            sx={{
              color: "white",
              backgroundColor: "rgba(0,0,0,0.7)",
              width: "20px",
              height: "20px",
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.9)",
              },
              marginTop: "-25%",
              marginRight: "-12.5%",
            }}
          >
            <CloseIcon sx={{ fontSize: "10px" }} />
          </IconButton>
        </Box>
      )}

      <Box
        style={{
          border: "2px solid rgba(28, 72, 107, 1)",
          borderRadius: "6px",
          padding: "1rem",
          textAlign: "center",
          cursor: "pointer",
          width: "100%",
          marginTop: "1rem",
          backgroundColor: isDragOver ? "#f1f1f1" : "#fff",
        }}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <input
          type="file"
          hidden
          id={`upload-document-${name}`}
          name={name}
          accept={accept}
          onChange={handleFileChange}
          ref={fileInputRef}
        />
        <label htmlFor={`upload-document-${name}`}>
          <Box display="flex" flexDirection="column" alignItems="center">
            <img src={uploadbutton} alt="Upload Icon" />
            <p
              style={{
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              Drop a file here or click to upload
            </p>
            <p
              style={{
                fontFamily: "Inter",
                fontSize: "12px",
                fontWeight: "400",
                textAlign: "center",
                marginTop: "-10px",
                marginBottom: "-0.5rem",
              }}
            >
              Upload your file (CSV, XLSX max 5 MB)
            </p>
          </Box>
        </label>
      </Box>

      {(errors || localError) && (
        <Typography variant="body2" color="#D34040">
          {errors || localError}
        </Typography>
      )}
    </Box>
  );
};

export default FileRead;
